import { Component, OnInit,ViewChild } from '@angular/core';
import { Platform ,ActionSheetController} from '@ionic/angular';
import { WebParameterContext } from '../../../../model/common';
import { HttpCustomerService, MessageclientService } from 'src/service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/service/common.service';

import { BaseCase } from 'src/app/basecase';
import { BaseModal } from 'src/model';
import {WxjssdkService}from 'src/service/wxjssdk.service';
declare var app;
@Component({
  selector: 'app-gift-receipt',
  templateUrl: './gift-receipt.component.html',
  styleUrls: ['./gift-receipt.component.scss']
})
export class GiftReceiptComponent implements OnInit {
  tabsIndex:any = 0;
  remarkvalue:any  ; //信息反馈字段
  pageName: string = null; // 产品分类
  
  FK_TBStore_ID: any;//赠品id
  SignerName:any;//签收人
  FK_TBStore_Name:any;// 门店名称
  SignTimeEffect:any;// 日期
  SignState:any; // 签收状态
  arrayData:Array<any>=[];
  arrayDatalist:Array<any>=[];
  erraMsg: any = null;
  uploadNum: any = [];
  PageNumber:number=0; //左边列表
  pageNameone: number = 0; // 产品所属于产品
  RecordCount: Number = 0;//列表总数量
  RecordCountone:Number = 0;//列表总数量
  giftsCategoryID: any; // 产品分类的id
  nctualNum: any; // 应到数量
  damagedNum: any; // 破损数量
  MessageFeedback:any; //信息反馈
  damageValueshow:boolean = false;
  _tempArray:Array<any>=[];
  imgUrlArr:Array<any> = [];

  ID:any;
  apiObj = {
    status: false,
    msg: ''
};//接口状态
loading: boolean = false;//加载效果
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase,
    public base: BaseModal,
    public weixin:WxjssdkService,
    private actionSheet:ActionSheetController
  ) { 
   //赠品调货SRL列表添加
   this.baseService.FixedSubmitBtn.text = "确认签收";
   this.baseService.FixedSubmitBtn.configName = "GiftReceiptForm";
   this.baseService.FixedSubmitBtn.isShow = true;
   this.baseService.FixedSubmitBtn.type = 20;
   this.pageName = this.activaRouter.snapshot.paramMap.get('ConfigName');
    activaRouter.queryParams.subscribe(queryParams => {
      this.FK_TBStore_ID =  queryParams.FK_TBStore_ID || null ; //赠品id
      this.SignerName= queryParams.SignerName || null; // 签收人
      this.FK_TBStore_Name= queryParams.FK_TBStore_Name || null // 门店名称
      if(queryParams.SignTimeEffect){
        this.SignTimeEffect= queryParams.SignTimeEffect.replace(/-/g,"/").replace("T","") || null // 日期
      }
      this.ID = queryParams.ID;// 列表id
      this.SignState = queryParams.SignState; //签收状态
      // if(this.SignState=="已签收"){//如果显示已签收则不可以继续签收
      //   this.baseService.FixedSubmitBtn.type = 20000;
      // }
      this.MessageFeedback = queryParams.MessageFeedback; // 信息反馈
      if(queryParams.Img){
        queryParams.Img.split(",").forEach(item=>{
          let _url:string= (app.FileUoloadUrl + item).replace(app.ImagePlaceholder,app.SmallImageType);
          console.log(_url,"文件地址路径");
          this.imgUrlArr.push({url:_url,name:item,"isUpload":true});
        });
      }
      if(this.SignState === "已签收"){
        this.damageValueshow = true;
        this.baseService.FixedSubmitBtn.type = 9999;
      }else{
        this.damageValueshow = false;
      }
  });

  }

  ngOnInit() {
  }
  // tab切换
  ipcConten(item,num){
    const that= this;
    that.tabsIndex = num;
    that.arrayDatalist = item.DetailList||[];
  }
  RemarkInput(e){
    let that=this;
   if(e&&e.target.value){
     if(e.target.value.length>120){
       e.target.value=e.target.value.substr(0,120);
       that.MessageFeedback=e.target.value;
      }
    }
  }

  
  ngAfterViewInit() {
    const that=this;
    that.LoadData(1);
    // that.MessageFeedback =  that.MessageFeedback; //信息反馈消息
   
   }
   doRefresh(event){
     
   }
  // 数组去重方法
 uniqueArry(arr) {
    if (!Array.isArray(arr)) {
        console.log('type error!')
        return
    }
    var array = [];
    for (var i = 0; i < arr.length; i++) {
        if (array .indexOf(arr[i]) === -1) {
            array .push(arr[i])
        }
    }
    return array;
}
   loadMoreData(event) {
     let that = this;
     that.PageNumber++;
     that.LoadData(that.PageNumber);
   }
   LoadData(PageNumber) {
     let that = this;
     that.PageNumber = PageNumber;
     if (PageNumber == 1) {
       that.loading = false;
       that.apiObj['status'] = false;
       that.apiObj['msg'] = '';
     }
      let _dy:any={
        "FK_TBGiftQuota_ID":  that.ID
      };
     const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
     const pageid = that.activaRouter.snapshot.paramMap.get('id');
     let body = new WebParameterContext();
     body.ConfigName="TBGiftQuotaByCategoryDetailInfo";
     body.OpType = "query";
     body.ConfigType = "view";
     body.RowsPerPage = 15;
     body.PageNumber =1;
     body.Client.PageName = PageName;
     body.Client.ApiType = "Element";
     body.Client.ClientType = 2;
     body.Client.Name= "product";
     body.RequestBody=JSON.stringify( _dy);
     that.http.post(app.DEFAULTURL, body).then(data => {
       if (data.ResponseMessage.Success) {
         that.arrayData=data.Status.Datas;
         if(that.arrayData.length>0){
         that.arrayDatalist=data.Status.Datas[0]["DetailList"]||[];
         }
       };
  
     }).catch(error => {
       that.apiObj['status'] = false;
       that.apiObj['msg'] = error.error.ResponseMessage.ErrorMessage;
       that.loading = true;
       console.log(error);
     });
   }
  //  右边详情数据
   loadMoreDataone(event) {
    let that = this;
    that.pageNameone++;
  }
  /**
   * 
   * @param item 当前对象
   * @param key 当前需要赋值的字段
   * @param i 数据下标
   */
  EventChanage(item,key,i,event){
    // debugger;
    item[key]=parseInt(event.target.value||0);
  }
  /**
   * 拍照页面
   */
  EventClickCamra(){
    const that=this;
    that.weixin.GetWxCamera(["camera"]).then(body=>{
      let _url:string= (app.FileUoloadUrl + body.Status[0].FileName).replace(app.ImagePlaceholder,app.SmallImageType);
      console.log(_url,"文件地址路径");
      that.imgUrlArr.push({url:_url,name:body.Status[0].FileName,"isUpload":true});
        }).catch(err=>{
            if(err.Status){
              console.log("上传照片失败");
              // that.imgUrlArr.push({url:err.Status,name:"","isUpload":false});
            }
        });
  }
  /**
   * 删除/查看照片
   * @param item 
   * @param i 
   */
 async EventClickEdite(item,i){
   const that=this;
   let _option1 = {
    // header: '',
    buttons: [{
      text: '预览',
      handler: () => {
        // console.log('预览');
        that.imgPreview(i);
      }
    }, {
      text: '删除',
      handler: () => {
        that.imgUrlArr.splice(i,1);
     
      }
    }, {
      text: '取消',
      role: 'cancel',
      handler: () => {
        console.log('Cancel clicked');
      }
    }]
  };
    const actionSheet = await that.actionSheet.create(_option1);
    await actionSheet.present();
  }
  /**
   * 
   * @param i 查看照片
   */
  imgPreview(i) {
    let that = this;
    let url = [];
    that.imgUrlArr.forEach(item=>{
      let u = null;
      if(item.url.indexOf("data:") > -1){
        u = item.url
      }else{
        u = item.url.trim().replace(app.SmallImageType,app.BigImageType);
      }
      url.push(u);
    })
    let ImgPreview = {
      imgUrl: url,
      index: i
    }
    that.com.setHistoryUrl(false);
    // localStorage.setItem("ImgPreview",JSON.stringify(ImgPreview));
    // that.router.navigate(["/tabs/contact/ImgPreview"]);
    that.com.Go("/tabs/contact/ImgPreview/"+that.com.getNowDatetime,{
      ImgPreview: JSON.stringify(ImgPreview)
    });
  }
  // 确认签收
  EventSubmitClick(){
    const that = this;
    console.log("GiftReceiptForm  sunb");
    let arrayDataListarry :Array<any>= [];
    // debugger;
    let isposun:boolean=false;//是否有破损
    let istype:number = 1;//实到等于应到
    let istrap:boolean = true;//破损大于应到数量；
    that.arrayData.forEach(items=>{
      items.DetailList.forEach(item => {
        // if(item.ActualNum || item.DamagedNum ){
          let _obj = {};
          _obj["ID"] = item.zid;
          _obj["FK_TBGift_ID"] = item.TBGiftID;
          _obj["ActualNum"] = item.ActualNum||0;
          _obj["DamagedNum"] = item.DamagedNum||0;
        if(item.DamagedNum){
          isposun=true;
            //如果破损大于应到数，提示不能签收
            if(item.DamagedNum>item.ShouldNum){
              istrap=false;//不可签收
            }
        }
        /**
         * 如果应到不等于实到则不签收
         */
        if(item.ShouldNum!=item.ActualNum){
          istype=0;
        }
      
        arrayDataListarry.push(_obj);
        // }
      });
    });
     if(!istrap){
       that.msg.Alert("破损不能大于应到数量");
       return;

     }
    //如果有破损,必须上传照片
    if(isposun){
      if(!that.MessageFeedback){
        that.msg.Alert("请填写信息反馈");
        return;
      }
      if(that.imgUrlArr.length<=0){
        that.msg.Alert("请上传照片");
        return;
      }
    }
    let img:string="";
    that.imgUrlArr.forEach(element => {
      img+=element.name+",";
    });
    img=img.substring(0,img.length-1);
    // 最后的总数据
    let objList ={
        "ID" :that.ID,
        "FK_TBStore_ID":that.FK_TBStore_ID,
        "MessageFeedback":that.MessageFeedback,
        "IsFit":istype,
        "ImgUrl":img, // 图片路径
        "GiftQuotaDetail":arrayDataListarry, // 列表修改数据

    }
    console.log(objList,"提交的数据提交的数据&&&&&&&&&&&")
    // return;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    const pageid = that.activaRouter.snapshot.paramMap.get('id');
    let body = new WebParameterContext();
    body.ConfigName="TBGiftQuota";
    body.OpType = "edite";
    body.ConfigType = "form";
    body.RowsPerPage = 15;
    body.PageNumber =1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Content";
    body.Client.Type="edite",
    body.Client.ClientType = 1;
    body.Client.Name= "temp_content";
    body.RequestBody=JSON.stringify( objList);
     that.msg.Confirm("确定签收吗？","取消","确定").then(res=>{
       if(res){
        that.http.post(app.DEFAULTURL, body).then(data => {
          if (data.ResponseMessage.Success) {
            that.msg.Alert("签收成功").then(res=>{
            that.com.goBack();
            });
          }else{
            that.msg.Alert(data.ResponseMessage.ErrorMessage);
          }
     
        }).catch(error => {
          that.msg.Alert(error.ResponseMessage.ErrorMessage);
          that.apiObj['status'] = false;
          that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
          that.loading = true;
          console.log(error);
        });
       }
     })

  }
}
